// src/components/GamesList.js
import React, { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import AddGameForm from './AddGameForm';
import GameModal from './GameModal';
import { colors } from '../styles/colors';

const GamesList = () => {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedGame, setSelectedGame] = useState(null);

  const fetchGames = async () => {
    try {
      const { data, error } = await supabase
        .from('games')
        .select('*')
        .order('id');
      if (error) throw error;
      setGames(data);
    } catch (err) {
      console.error(err);
      setGames([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGames();

    if (!supabase.channel) return;
    const channel = supabase
      .channel('public:games')
      .on('postgres_changes', { event: '*', schema: 'public', table: 'games' }, (payload) => {
        if (payload.eventType === 'INSERT') setGames((prev) => [...prev, payload.new]);
        if (payload.eventType === 'UPDATE') setGames((prev) =>
          prev.map((g) => (g.id === payload.new.id ? payload.new : g))
        );
        if (payload.eventType === 'DELETE') setGames((prev) =>
          prev.filter((g) => g.id !== payload.old.id)
        );
      })
      .subscribe();
    return () => supabase.removeChannel(channel);
  }, []);

  const filteredGames = games.filter((g) =>
    g.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap', padding: '1rem' }}>
      <div style={{ flex: '2 1 400px', minWidth: '300px' }}>
        <h2 style={{ color: colors.primary }}>Games</h2>

        <input
          type="text"
          placeholder="Search games..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            width: '100%',
            padding: '0.5rem 0.75rem',
            marginBottom: '1rem',
            borderRadius: '8px',
            border: `1px solid ${colors.primary}`,
            outline: 'none',
            fontSize: '0.95rem',
          }}
        />

        {loading ? (
          <p>Loading...</p>
        ) : filteredGames.length === 0 ? (
          <p>No games found.</p>
        ) : (
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
              gap: '1rem',
            }}
          >
            {filteredGames.map((g) => (
              <div
                key={g.id}
                onClick={() => setSelectedGame(g)}
                style={{
                  backgroundColor: colors.background,
                  padding: '1rem',
                  borderRadius: '12px',
                  border: `1px solid ${colors.primary}20`,
                  boxShadow: '0 8px 18px rgba(0,0,0,0.08)',
                  cursor: 'pointer',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 12px 25px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 8px 18px rgba(0,0,0,0.08)';
                }}
              >
                <h3 style={{ margin: '0 0 6px 0', color: colors.primary }}>🎮 {g.title}</h3>
                <p style={{ margin: 0, fontWeight: '500', color: colors.textLight }}>
                  Release Year: {g.release_year || 'Unknown'}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>

      <div style={{ flex: '1 1 300px', minWidth: '280px' }}>
        <AddGameForm onGameAdded={(newGame) => setGames((prev) => [...prev, newGame])} />
      </div>

      <GameModal game={selectedGame} onClose={() => setSelectedGame(null)} />
    </div>
  );
};

export default GamesList;